var _path, _path2, _path3, _path4, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOwnMechLandLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 560,
    height: 38,
    viewBox: "0 0 560 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M528 20L528 18L539 18L557 -2.16962e-06L560 -1.90735e-06L539.97 20L528 20Z",
    fill: "#565656"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 20L32 18L21 18L3 -2.16962e-06L-1.74846e-06 -1.90735e-06L20.03 20L32 20Z",
    fill: "#565656"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 18L32 20L21 20L3 38L-1.74846e-06 38L20.03 18L32 18Z",
    fill: "#565656"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M528 18L528 20L539 20L557 38L560 38L539.97 18L528 18Z",
    fill: "#565656"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 18,
    width: 496,
    height: 2,
    fill: "#565656"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 16,
    width: 40,
    height: 6,
    fill: "#00F7AB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwnMechLandLine);
export default __webpack_public_path__ + "static/media/ownMechLandLine.8b45d1302b8ef4721ec1ea61a06b39c2.svg";
export { ForwardRef as ReactComponent };